import { useSelector } from 'react-redux';
import { Divider, Text } from '@vinted/web-ui';
import useTranslate from 'hooks/useTranslate';
import * as selectors from 'state/auth/selectors';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const BusinessRegistrationLink = () => {
  const isLoginView = useSelector(selectors.getIsSelectTypeLogin);
  const isBusinessRegistrationLinkVisible = useSelector(selectors.getIsBusinessRegistrationLinkVisible);
  const translate = useTranslate();
  if (!isBusinessRegistrationLinkVisible || isLoginView) return null;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx("div", {
      className: "u-ui-padding-horizontal-large u-ui-padding-vertical-x-large",
      children: /*#__PURE__*/_jsx(Text, {
        type: Text.Type.Caption,
        alignment: Text.Alignment.Center,
        text: translate('auth.select_type.register.are_you_a_business'),
        width: Text.Width.Parent,
        html: true
      })
    })]
  });
};

export default BusinessRegistrationLink;